<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()
const appVersion = __APP_VERSION__
const appCommit = __APP_COMMIT__
</script>

<template>
  <a-layout-footer class="footer">
    <span>
      <router-link to="/about">CasaMana</router-link> © {{ new Date().getFullYear() }}
      <a-divider type="vertical" />
      <a @click="router.push('/help')">Need help?</a>
    </span>
    <span class="version">v{{ appVersion }} ({{ appCommit }})</span>
  </a-layout-footer>
</template>

<style scoped>
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--text-muted);
  font-size: 12px;
  padding: 6px 16px;
  line-height: 1;
}
.version {
  font-size: 12px;
  opacity: 0.6;
}
</style>
